import React, { useContext, useCallback } from "react";
import { motion } from "framer-motion";

import AreaIcon from "../areaIcon/AreaIcon";
import Container from "../../hoc/container/Container";

import LifeAreasContext from "../../contexts/LifeAreasContext";
import lifeAreasData from "../../resources/lifeAreas";

import style from "./AreasPicker.module.css";

const AreasPicker = () => {
  const { lifeAreas: areasState, dispatchLifeAreas } = useContext(
    LifeAreasContext
  );

  const iconTapped = useCallback(
    (key: string) => {
      // Only allowed 3 areas
      if (areasState.keys.includes(key)) {
        dispatchLifeAreas({ type: "REMOVE_AREA", key: key });
      } else if (areasState.keys.length < 3) {
        dispatchLifeAreas({ type: "ADD_AREA", key: key });
      }
    },
    [areasState, dispatchLifeAreas]
  );

  const variants = {
    visible: (custom: number) => ({
      opacity: 1,
      scale: 1,
      transition: { delay: custom * 0.08 },
    }),
  };

  return (
    <Container containerClass={style.container}>
      <div className={style.areas}>
        {Object.keys(lifeAreasData).map((areaKey, index) => (
          <motion.div
            key={index}
            custom={index}
            variants={variants}
            initial={{ opacity: 0, scale: 0.8 }}
            animate="visible"
          >
            <AreaIcon
              area={lifeAreasData[areaKey]}
              showLabel={true}
              style={{}}
              isHighlighted={areasState.keys.includes(areaKey)}
              onTap={() => iconTapped(areaKey)}
            />
          </motion.div>
        ))}
      </div>
    </Container>
  );
};

export default AreasPicker;

/* Selected Life Areas
        <div className={style.selectedAreas}>
          {areasState.keys.map((areaKey, index) => (
            <div key={index}>
              <ValueIcon
                key={areaKey + "1"}
                // index={index}
                area={lifeAreasData[areaKey]}
                showLabel={true}
                onTap={() =>
                  dispatchAreas({ type: "REMOVE_AREA", key: areaKey })
                }
              />
            </div>
          ))}
        </div> */
